import React, { useState } from "react";
import "./IslamicTrade.css";

import { Link } from "react-router-dom";
import BadgePopup from "../components/Badgepopup";
import FloatingPageNav from "../components/FloatingPageNav";
import Question from "../components/Question";

function DIY100() {
  const [isOpen, setIsOpen] = useState(true);

  const links = {
    prev: "/diy-99",
    index: "/index-diy",
    next: "/diy-100",
  };
    
  return (
    <div className="container">
   
      <h1>DIY 100</h1>
        
      <h2>Work In Progress</h2>
      {/* <p className="content">
       */}
      
      
      
      
      
      
      {/* <b>Summary of Today’s Lesson</b>
        <br />
        <br />
         <b> Coming Up Next</b>
        <br />
        <br />
      </p>
      <h2>Test your understanding</h2> */}
      <FloatingPageNav
        prevLink={links.prev}
        indexLink={links.index}
        nextLink={links.next}
      />
      <BadgePopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        level="Level 8"
        badgeImg="./achieve.png"
        heading="Trustless Infrastructure Builder"
        subtitle="Graduate – Sovereign Skills Lab"
        mainImg="./trustlessinfrastructurebuilder.png"
        description="Honors mastery of practical Bitcoin sovereignty. You are capable of running infrastructure, securing wealth through offline key generation, operating miners or nodes, and building systems that eliminate reliance on centralized trust."
      />
    </div>
  );
}

export default DIY100;
